export function getSpartacusLoadingPresentation({ loading, hasData }) {
  return {
    showInitialLoader: Boolean(loading && !hasData),
    showRefreshOverlay: Boolean(loading && hasData),
  }
}
